<template>
  <g>
    <g>
      <path fill="#7E57C2" :style="{fill : $attrs.fgColor}"
            d="M25.2,22.3c-0.5-0.3-1.3-0.6-1.8-0.6c-0.3,0-0.6,0.2-0.9,0.4c-0.5,0.5-0.7,1.2-1.7,1.2c-0.9,0-2.6-1-3.8-2.2
		C16,20,15,18.3,15,17.4c0-1,0.7-1.1,1.2-1.7c0.2-0.2,0.4-0.6,0.4-0.9c0-0.4-0.3-1.2-0.6-1.8c-0.8-1.3-1-1.7-1.8-2.6
		C14,10.1,13.7,10,13.4,10c-0.5,0-1.2,0.3-1.7,0.6c-0.7,0.5-1.5,1.3-1.7,2.2c0,0.1,0,0.2,0,0.4c0,0.9,0.3,1.9,0.7,2.7
		c0.9,1.9,2.2,3.7,3.5,5.4c0.4,0.5,0.9,1,1.4,1.5c0.5,0.5,1,1,1.5,1.4c1.6,1.3,3.5,2.6,5.4,3.5c0.8,0.4,1.7,0.8,2.7,0.7
		c0.1,0,0.3,0,0.4,0c0.9-0.2,1.6-0.9,2.2-1.7c0.4-0.5,0.6-1.2,0.6-1.7c0-0.3-0.1-0.6-0.5-0.9C27,23.3,26.5,23,25.2,22.3z"/>
      <path fill="#7E57C2" :style="{fill : $attrs.fgColor}"
            d="M20,9.2c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8c4.1,0,7.5,3.4,7.5,7.5v0.8c0,0.5,0.4,0.8,0.8,0.8
		c0.5,0,0.8-0.4,0.8-0.8v-0.8C29.2,13.3,25.1,9.2,20,9.2z"/>
      <path fill="#7E57C2" :style="{fill : $attrs.fgColor}"
            d="M21,14.3c-0.4-0.1-0.9,0.2-1,0.6c-0.1,0.4,0.2,0.9,0.6,1c0.9,0.2,1.6,0.9,1.8,1.8c0.1,0.4,0.4,0.6,0.8,0.6
		c0.1,0,0.1,0,0.2,0c0.4-0.1,0.7-0.6,0.6-1C23.6,15.8,22.5,14.7,21,14.3z"/>
      <path fill="#7E57C2" :style="{fill : $attrs.fgColor}"
            d="M25.8,19.2c0.5,0,0.8-0.4,0.8-0.8c0-3.5-2.8-6.5-6.3-6.7c-0.5,0-0.9,0.3-0.9,0.8c0,0.5,0.3,0.9,0.8,0.9
		c2.7,0.1,4.7,2.3,4.7,5C25,18.8,25.4,19.2,25.8,19.2z"/>
    </g>
    <path fill="#7E57C2" :style="{fill : $attrs.fgColor}"
          d="M20,3.3c-3.8,0-9.6,0.3-13.2,3.6c-2.5,2.5-3.5,6-3.5,10.6c0,0.4,0,0.8,0,1.2c0,0.5,0,0.9,0,1.2
	c0,4.5,1,8.1,3.5,10.6c1.4,1.2,3,2.1,4.8,2.6V37c0,1.3,0.9,1.4,1,1.4h0c0.4,0,0.8-0.2,1.1-0.5c0.1-0.1,1.7-1.8,3.4-3.7
	c1,0.1,2,0.1,2.8,0.1l0,0l0,0c3.8,0,9.6-0.3,13.2-3.6c2.5-2.5,3.5-6,3.5-10.6c0-0.4,0-0.8,0-1.2c0-0.5,0-0.9,0-1.2
	c0-4.5-1-8.1-3.5-10.6C29.6,3.7,23.8,3.3,20,3.3z M34.2,19.7V20c0,4.1-0.9,6.9-2.7,8.8c-3.2,2.9-9.4,2.9-11.4,2.9
	c-0.6,0-1.6,0-2.8-0.1c-0.3,0.4-3.9,4.3-3.9,4.3V31c-1.8-0.4-3.5-1.1-4.8-2.3c-1.9-1.9-2.7-4.7-2.7-8.8v-0.3c0-0.3,0-0.6,0-1
	c0-0.3,0-0.6,0-0.9v-0.3c0-4.1,0.9-6.9,2.7-8.8C11.8,5.8,18,5.8,20,5.8s8.2,0,11.4,2.9c1.9,1.9,2.7,4.7,2.7,8.8v0.3c0,0.3,0,0.6,0,1
	C34.2,19.1,34.2,19.4,34.2,19.7z"/>
  </g>
</template>

<script>
export default {
  name: "svgViber"
}
</script>

<style scoped>

</style>